import * as React from 'react';
import {useDispatch, useSelector} from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  changeBackArrowAction,
  selectBackArrowState,
} from '../../ducks';

export const SlideInHeader = ({ titleText, clickHandler  }) => {
  const dispatch = useDispatch();
  const backButtonActive = useSelector(selectBackArrowState);

  return (
    <div className={'slideheader'}>
      {backButtonActive
        ? <div
          onClick={() => dispatch(changeBackArrowAction(!backButtonActive))}
        >
          <FontAwesomeIcon icon="long-arrow-alt-left" size="2x" />
        </div>
        : null}
      <h2>{titleText}</h2>
      <div
        aria-label="close"
        onClick={() => dispatch(clickHandler)}
      >
        <FontAwesomeIcon icon={['fas', 'times']} size="2x" />
      </div>
    </div>
  );
};